import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as selectores from "app/features/selectores/simples";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";

type Entity = models.InfoPromRecibidas;
export interface Props {
    value: Entity;
    title: string;
    style?: "default" | "primary" | "success" | "info" | "warning" | "danger";
    onChange: (value: Entity) => PromiseLike<void>;
    readonly?: boolean;
    error?: kea.FieldError;
}

/**
* Componente para editar un Entity
*/
class InfoComRecibidasPromedioComponentNoRx extends React.PureComponent<Props> {
    value = (props: Props) => this.props.value;
 
    errors = () => validation.getErrors(this.rules, this.props.value);

    getField = formfields(() => this.props, () => this.errors());

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value , title, style } = this.props;
        const getField = this.getField;
        const Number = getField(kea.Number);
        
        return (
            <div>
                <kea.Panel title={title} iconClass={fa("id-card-o")} style={style}>
                    {kea.autogrid(3, [
                        <Number field="Precio" label="Precio" />,
                        <Number field="PaqXGuia" label="Paquetes x guía" />,
                        <Number field="VentaXGuia" label="Venta x guía" />,
                    ])}
                </kea.Panel>
            </div>);
    }
}

export const InfoComRecibidasPromedioPromedioComponent = componentToRx(kea.mapProps(InfoComRecibidasPromedioComponentNoRx, x => ({ ...x, value: x.value || {} })), <kea.Spinner />, undefined, {
    error: { ignore: { observable: true, promise: true } }
});


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/edit/informacioncomercial/informacionPorMes/componentes/informacionrecibidaspromedio.tsx